module.exports = __webpack_public_path__ + "qa.svg?4f43367e98f4cb669dd1a67d66162e86";